import { users } from "@/api/users/useUsersQuery";
import { translateWithPartnerType } from "@/utils/partnerType";
import { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { Checkbox, Flex, useMantineColorScheme } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

interface PurchaseOrderTableInRowHeadProps {
  isAllChecked: boolean;
  handleToggleAll: () => void;
  pageKey: "purchaseOrder" | "order";
}
export const PurchaseOrderTableInRowHead = (params: PurchaseOrderTableInRowHeadProps) => {
  const { isAllChecked, handleToggleAll, pageKey } = params;
  const { colorScheme } = useMantineColorScheme();
  const { t } = useTranslation();
  const { data: userInfo } = useQuery(users.who({}));
  const partnerType = userInfo?.data?.partner?.type;

  return (
    <Thead theme={{ colorScheme }}>
      <Th>
        <Flex justify="center">
          <Checkbox checked={isAllChecked} onChange={handleToggleAll} />
        </Flex>
      </Th>
      <Th>
        {pageKey === "purchaseOrder" ? t("purchaseOrderItems.status") : t("orderItems.status")}
      </Th>
      <Th>품목군</Th>
      <Th>{t("item.name")}</Th>
      <Th>Grade명</Th>
      <Th>{t("item.category")}</Th>
      <Th>{t("item.abstractItemCode")}</Th>
      <Th>{t(`${pageKey}.toLocationName`)}</Th>
      <Th>{t("inventory.quantity")}</Th>
      <Th>{t("purchaseOrderItems.sumOfProductionPlanQuantity")}</Th>
      <Th>
        {pageKey === "purchaseOrder"
          ? t("purchaseOrderItems.sumOfStockPlanQuantity")
          : t("orderItems.sumOfStockPlanQuantity")}
      </Th>
      <Th>
        {pageKey === "purchaseOrder"
          ? t("purchaseOrderItems.sumOfDeliveredQuantity")
          : t("orderItems.sumOfDeliveredQuantity")}
      </Th>
      <Th>{translateWithPartnerType(t, "purchaseOrder.orderDate", partnerType)}</Th>
      <Th>{t("order.deliveryDate")}</Th>
      <Th>{t("common.action")}</Th>
    </Thead>
  );
};

export const Thead = styled.thead<{ theme: Theme & { colorScheme: "dark" | "light" } }>`
  height: 40px;
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  top: 0;
  z-index: 1;
  background-color: ${({ theme }) =>
    theme.colorScheme === "dark" ? "var(--gray-9, #111)" : "var(--gray-0, #f5f5f5)"};
`;

export const Th = styled.th`
  padding: 0 10px;
  border: 1px solid #e0e0e0;
`;
